import React from 'react';
import { Props as SectionHeaderProps, SectionHeader } from '../SectionHeader';

export type Props = React.HTMLAttributes<HTMLDivElement> &
  SectionHeaderProps & {
    title?: string;
  };

const Section: React.FC<Props> = ({
  title,
  icon,
  actionTo,
  actionTitle,
  styleSlug,
  children,
  ...props
}) => (
  <section {...props}>
    {title && (
      <SectionHeader
        icon={icon}
        actionTo={actionTo}
        actionTitle={actionTitle}
        styleSlug={styleSlug}
      >
        {title}
      </SectionHeader>
    )}
    {children}
  </section>
);

export default Section;
